import { render, staticRenderFns } from "./headerIndex.vue?vue&type=template&id=47b06c64&scoped=true&"
import script from "./headerIndex.vue?vue&type=script&lang=js&"
export * from "./headerIndex.vue?vue&type=script&lang=js&"
import style0 from "./headerIndex.vue?vue&type=style&index=0&id=47b06c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b06c64",
  null
  
)

export default component.exports